import appConfig from './sejutakg';

const NAMESPACE = 'sejutakg';
const ENDPOINT = 'identity';
const REDIRECT_URI = `${window.location.origin}/auth/callback`;
const PDA_AUTH_BASE_URL = 'https://hatters.dataswift.io';
const JWT_TOKEN_KEY = 'jwt-token';
const USER_ROLE_KEY = 'user-role';
const PRODUCTION_DOMAIN = 'datapassport.com';

const DEV_API_PREFIX = "https://sejutakg.datapassport.dev";
const PROD_API_PREFIX = "https://sejutakg.datapassport.com";

const DEV_APPLICATION_ID = "tv-s-sejutakgdatapassport";
const PROD_APPLICATION_ID = "tv-p-sejutakgdatapassport";


export const isProduction = window.location.origin.includes(PRODUCTION_DOMAIN);
export const apiPrefix = isProduction ? PROD_API_PREFIX : DEV_API_PREFIX
export const applicationId = isProduction ? PROD_APPLICATION_ID : DEV_APPLICATION_ID

const commonConfig = {
  dataswiftLink: 'https://dataswift.io',
  termsOfService: 'https://www.datapassport.com/datavista/terms-and-conditions',
  privacyPolicy: 'https://www.datapassport.com/datavista/privacy-policy',
  eula: 'http://datapassport.com/datavista/passport-holder-eula',
  merchantEula: 'https://www.datapassport.com/legal/merchant-eula',
  namespace: NAMESPACE,
  dsNamespace: "dataswift",
  endpoint: ENDPOINT,
  jwtTokenKey: JWT_TOKEN_KEY,
  userRoleKey: USER_ROLE_KEY,
  apiPrefix: apiPrefix
};

export const config = {
  ...appConfig(isProduction, PDA_AUTH_BASE_URL, REDIRECT_URI),
  ...commonConfig,
};
